export const updateUserSettings = (userSettings) => (dispatch) => {
  dispatch({
    type: 'SET_ADMIN_USER_SETTINGS',
    payload: userSettings,
  })
  return Promise.resolve()
}

export const updateShowChatbotConnectionError =
  (showChatbotConnectionError) => (dispatch) => {
    dispatch({
      type: 'SET_SHOW_CHATBOT_CONNECTION_ERROR',
      payload: showChatbotConnectionError,
    })
    return Promise.resolve()
  }

export const updateChatbotRetryCount = (chatbotRetryCount) => (dispatch) => {
  dispatch({
    type: 'SET_CHATBOT_RETRY_COUNT',
    payload: chatbotRetryCount,
  })
  return Promise.resolve()
}
